import React, { useEffect, useState } from "react";
import { Panel, Field } from "@/pages/admin/shared";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Save } from "lucide-react";
import { toast } from "sonner";
import api from "@/pages/admin/api";

export default function ContactEditor() {
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { api.get("/site-content").then((r) => setData(r.data.contact || {})); }, []);
  if (!data) return <div className="text-sm text-muted-foreground">Loading…</div>;

  const set = (k, v) => setData({ ...data, [k]: v });

  const save = async () => {
    setSaving(true);
    try { await api.put("/site-content", { contact: data }); toast.success("Contact page updated"); }
    catch { toast.error("Save failed"); }
    finally { setSaving(false); }
  };

  return (
    <Panel title="Contact Page Content" actions={<Button data-testid="save-contact-page" onClick={save} disabled={saving} className="rounded-xl bg-blue-600 hover:bg-blue-700 text-white"><Save size={14} className="mr-1" /> {saving ? "Saving..." : "Save"}</Button>}>
      <div className="grid md:grid-cols-2 gap-4">
        <Field label="Heading"><Input data-testid="contact-heading" value={data.heading || ""} onChange={(e) => set("heading", e.target.value)} /></Field>
        <Field label="Working Hours"><Input value={data.working_hours || ""} onChange={(e) => set("working_hours", e.target.value)} /></Field>
        <Field label="Description" className="md:col-span-2"><Textarea rows={3} value={data.description || ""} onChange={(e) => set("description", e.target.value)} /></Field>
        <Field label="Email"><Input type="email" value={data.email || ""} onChange={(e) => set("email", e.target.value)} /></Field>
        <Field label="Phone"><Input value={data.phone || ""} onChange={(e) => set("phone", e.target.value)} /></Field>
        <Field label="Address" className="md:col-span-2"><Textarea rows={2} value={data.address || ""} onChange={(e) => set("address", e.target.value)} /></Field>
        <Field label="Google Map Embed URL" className="md:col-span-2" hint="Paste the src URL from Google Maps embed code">
          <Input value={data.map_embed || ""} onChange={(e) => set("map_embed", e.target.value)} />
        </Field>
      </div>
    </Panel>
  );
}
